"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CloseCircleFill = _interopRequireDefault(require("@zenlayer/zen-design-icons/assets/suggest/CloseCircleFill.svg"));
var _Ellipsis = _interopRequireDefault(require("@zenlayer/zen-design-icons/assets/general/Ellipsis.svg"));
var _button = _interopRequireDefault(require("../button"));
var _dropdown = _interopRequireDefault(require("../dropdown"));
var _icon = _interopRequireDefault(require("../icon"));
var _space = _interopRequireDefault(require("../space"));
var _tooltip = _interopRequireDefault(require("../tooltip"));
var _ahooks = require("ahooks");
var _classnames = _interopRequireDefault(require("classnames"));
var _ramda = require("ramda");
var _react = _interopRequireWildcard(require("react"));
var _useConfig = require("../hooks/useConfig");
var _locale = require("../locale");
var _ActionMenu = require("./tbodyOpts/ActionMenu");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SelectionModal = props => {
  const {
    selectedRowKeys,
    onChange,
    operation,
    otherOperation,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style
  } = props;
  const {
    locale: {
      Table: TableLocale
    }
  } = (0, _useConfig.useConfig)();
  const baseClassName = "".concat(prefixClass, "-selectionModal");
  const [visible, setVisible] = (0, _react.useState)(!!(selectedRowKeys !== null && selectedRowKeys !== void 0 && selectedRowKeys.length));
  (0, _ahooks.useUpdateEffect)(() => {
    setVisible(!!(selectedRowKeys !== null && selectedRowKeys !== void 0 && selectedRowKeys.length));
  }, [selectedRowKeys]);
  const [calculateOpts, calculateOtherOpts] = (0, _react.useMemo)(() => {
    const availableOpt = (operation === null || operation === void 0 ? void 0 : operation.filter(i => !!i)) || [];
    const optNum = availableOpt.length;
    const availableOtherOpt = (otherOperation === null || otherOperation === void 0 ? void 0 : otherOperation.filter(i => !i.hidden)) || [];
    const otherOptNum = availableOtherOpt.length;
    if (otherOptNum > 0 && optNum < 2) {
      return [[...availableOpt, (0, _ramda.take)(2 - optNum, availableOtherOpt).map(item => {
        const tooltipProps = item.tooltips ? item.tooltips : {
          title: undefined
        };
        return /*#__PURE__*/(0, _react.createElement)(_tooltip.default, {
          ...tooltipProps,
          key: item.key
        }, /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.default, {
          size: "s",
          type: "normal",
          disabled: item.disabled,
          danger: item.danger,
          onClick: item.onClick,
          children: item.text
        }));
      })], (0, _ramda.drop)(2 - optNum, availableOtherOpt)];
    } else {
      return [availableOpt, availableOtherOpt];
    }
  }, [operation, otherOperation]);
  if (!visible) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _classnames.default)(baseClassName, className),
    style: style,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "content",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_space.default, {
        align: "center",
        size: "ll",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: (0, _locale.getTransedText)(TableLocale.selectionModal_total, {
            selectedTotal: selectedRowKeys === null || selectedRowKeys === void 0 ? void 0 : selectedRowKeys.length
          })
        }), !!calculateOpts.length && /*#__PURE__*/(0, _jsxRuntime.jsx)(_space.default, {
          align: "center",
          children: calculateOpts
        }), !!calculateOtherOpts.length && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "divider",
            children: "|"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dropdown.default, {
            placement: "top",
            getPopupContainer: t => t.parentNode,
            menu: (0, _ActionMenu.createMenu)(calculateOtherOpts),
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.default, {
              type: "normal",
              size: "s",
              textBaseColor: true,
              icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
                type: "general/Ellipsis"
              })
            })
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
          type: "suggest/CloseCircleFill",
          className: "closeIcon",
          fontSize: 24,
          onClick: () => {
            onChange([]);
            setVisible(false);
          }
        })]
      })
    })
  });
};
var _default = exports.default = SelectionModal;